
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { baseApiURL } from 'src/utils/utils'
import styles from './frontpage.module.scss'
import Input from 'src/components/input/Input'
import Button from 'src/components/button/Button'
import useQuery from 'src/utils/useQuery'
import { useHistory } from 'react-router'
import { validPassword, resetError, handleInputChange, handleValidation } from 'src/utils/utils'
import { toast } from 'react-toastify'
import useCancellablePromise from 'src/utils/useCancellablePromise'

interface IValues {
  password: string
  confirmPassword: string
}

interface IErrors {
  confirmPassword: boolean
  password: boolean
}

const Register: React.FunctionComponent = () => {
  const query = useQuery()
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const companyId = query.get('company_id')
  const [companyInfo, setCompanyInfo] = useState({
    imageUrl: '',
    hexColor: '',
    name: ''
  })
  const [conflictingCredentials, setConflictingCredentials] = useState(false)
  const [validationErrors, setValidationErrors] = useState<IErrors>({
    password: false,
    confirmPassword: false
  })
  const { cancellablePromise } = useCancellablePromise()
  const [error, setError] = useState(false)
  const [values, setValues] = useState<IValues>({
    password: '',
    confirmPassword: ''
  })

  useEffect(() => {
    cancellablePromise(axios(`${baseApiURL()}/companies/${companyId}/image_url`)
      .then((result: any) => {
        setCompanyInfo(result.data)
      }).catch((err) => {
        setError(true);
        toast(err.response.data.message)
      }))
  }, [companyId, cancellablePromise])

  const activateUser = (e) => {
    e.preventDefault();
    if (values.confirmPassword === values.password) {
      setIsLoading(true)
      axios.put(`${baseApiURL()}/users/activate`,
        {
          password: values.password,
          confirmPassword: values.confirmPassword,
          activationKey: query.get("activation_key")
        }).then(() => {
          setIsLoading(false)
          history.push('/login')
        }).catch((err) => {
          toast(err.response.data.message)
          setIsLoading(false)
          setError(true);
        })
    } else {
      setConflictingCredentials(true)
    }
  }

  return (
    <div className={styles.module}>
      {companyInfo.imageUrl ?
        <img className={styles.icon} alt="" src={companyInfo.imageUrl} /> :
        <span style={{ background: companyInfo.hexColor }} className={styles.icon}>{companyInfo.name.charAt(0)}</span>}
      <form onSubmit={activateUser}>
        <Input
          name='password'
          label='Kodeord'
          error={conflictingCredentials || validationErrors.password || error}
          placeholder='Indtast dit kodeord'
          type='password'
          resetError={() => resetError('password', setValidationErrors, validationErrors, setConflictingCredentials)}
          handleInputChange={() => handleInputChange('password', setValues, values)}
          handleValidation={() => handleValidation(validPassword, 'password', setValidationErrors, validationErrors)}
        />
        {validationErrors.password && <p className='errorMsg'>Kodeord skal indeholde 12 tegn.</p>}

        <Input
          name='confirmPassword'
          label='Gentag kodeord'
          error={conflictingCredentials || validationErrors.confirmPassword || error}
          placeholder='Indtast dit kodeord'
          legalText='Kodeord skal indeholde 12 tegn.'
          type='password'
          resetError={() => resetError('confirmPassword', setValidationErrors, validationErrors, setConflictingCredentials)}
          handleInputChange={() => handleInputChange('confirmPassword', setValues, values)}
          handleValidation={() => handleValidation(validPassword, 'confirmPassword', setValidationErrors, validationErrors)}
        />
        {validationErrors.confirmPassword && <p className='errorMsg'>Kodeord skal indeholde 12 tegn.</p>}
        {conflictingCredentials && <p className='errorMsg'>Adgangskoden stemmer ikke overens</p>}
        {error && <p className='errorMsg'>Der gik desværre noget galt. Prøv igen om lidt</p>}
        <Button
          label='Opret profil'
          type='primary'
          submit={true}
          loading={isLoading}
          modifiers='tw-mt-5 tw-w-full tw-justify-center'
          disabled={!(values.password && values.confirmPassword) || (validationErrors.password || validationErrors.confirmPassword)}
        />
      </form>
    </div>
  )
}

export default Register